export interface AvailabilityMetricInput {
	ddd?: number | null;
	dddShare?: number | null;
	odtd?: number | null;
	odtdShare?: number | null;
	packages: number;
	packagesShare: number;
}

export interface AvailabilityMetric {
	/** Label of the metric tier actually used (DDD / ODTD / BALENÍ). */
	label: string;
	value: number;
	/** Share of the ATC/RS group for the resolved tier, expressed as a fraction (0-1). */
	share: number;
}

/**
 * Resolves which availability metric tier should be displayed, falling back
 * DDD -> ODTD -> packages when the preferred tier is unavailable (null).
 *
 * Mirrors the backend fallback order used to compute `decisionDetails.isOverThreshold`
 * (see CzechSuklRsAtcGroupService#hasShareOverThreshold).
 *
 * @param {AvailabilityMetricInput} availability the raw availability payload from the API.
 * @returns {AvailabilityMetric} the resolved tier to display.
 */
export function resolveAvailabilityMetric(availability: AvailabilityMetricInput): AvailabilityMetric {
	if (availability.ddd != null || availability.dddShare != null) {
		return { label: 'DDD', value: availability.ddd ?? 0, share: availability.dddShare ?? 0 };
	}
	if (availability.odtd != null || availability.odtdShare != null) {
		return { label: 'ODTD', value: availability.odtd ?? 0, share: availability.odtdShare ?? 0 };
	}
	return { label: 'BALENÍ', value: availability.packages, share: availability.packagesShare };
}
